export default "__VITE_ASSET__CbiqgiTb__"